import styled from 'styled-components';
import theme from '../theme';
import fn from '../../helpers/fn';

export default fn(__filename, styled.h1`
  font-size: 52px;
  font-weight: 300;
  line-height: 1.275;
  margin: 0 0 ${2 * theme.unit}px;
  color: white;
  text-align: left;

  span {
    white-space: nowrap;
  }

  @media screen and (max-width: 640px) {
    font-size: 40px;
    margin: 0 0 ${2 * theme.unit}px;
    text-align: center;
  }
`);



// WEBPACK FOOTER //
// ./src/components/headings/PageIntro.js